import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['No tenés los diseños listos para imprimir y vender YA', 'Cuando ves a otros vendiendo stickers del Mundial, no sabés cómo entrar', 'No querés perder semanas diseñando desde cero', 'Querés aprovechar el Mundial 2026 pero el tiempo pasa y no arrancás', 'Cada semana te decís "esta semana lo lanzo" y no pasa nada'];
  return <section className="py-20 bg-black" data-id="element-162">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-164">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-165">
            ¿Cuántas oportunidades más vas a dejar pasar mientras otros ganan
            dinero con el Mundial?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-166">
            <p className="text-[14px]" data-id="element-167">
              El Mundial 2026 es el evento más grande del planeta. Millones de
              personas van a querer stickers de sus jugadores favoritos, de la
              Selección, de los equipos del mundo. Y vos podés ser quien se los
              venda.
            </p>
            <p data-id="element-168">
              <strong className="text-white text-[16px]" data-id="element-169">
                El problema no sos vos. El problema es que no tenías los diseños
                listos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-170">
          <ul className="space-y-4" data-id="element-171">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-172">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-173">
                  <X className="w-4 h-4 text-red-400" data-id="element-174" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-175">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-176">
          <p className="font-bold text-sky-400 text-[16px]" data-id="element-177">
            ¿Y si esta fuera la última semana que dejás pasar esta oportunidad?
          </p>
        </div>
      </div>
    </section>;
}